// Creates object of slides depends on qty of files per slide
export const buildSlides = (files, filesPerSlide) => {
  return files.reduce(function (result, file, index) {
    const slideIndex = Math.floor(index / filesPerSlide)
    result[slideIndex] = result[slideIndex] || []
    result[slideIndex].push(file)
    return result
  }, {})
}
